
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-glam",
      function () {
        return require("private-next-pages/group-glam.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group-glam"])
      });
    }
  